"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseMobile = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const polished_1 = require("polished");
const BaseMobile = ({ content, className }) => {
    return ((0, jsx_runtime_1.jsx)(Container, { className: className, children: (0, jsx_runtime_1.jsx)("div", { onClick: (e) => e.stopPropagation(), children: content }, void 0) }, void 0));
};
exports.BaseMobile = BaseMobile;
const Container = styled_components_1.default.div `
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  background-color: ${({ theme }) => (0, polished_1.transparentize)(0.5, theme.colors.greyBase)};
  z-index: 20;
  overflow: auto;

  & > div {
    background: ${({ theme }) => theme.colors.whiteBase};
    border-top-right-radius: 30px;
    border-top-left-radius: 30px;
    border-bottom: none;
    height: calc(100% - ${({ theme }) => theme.spacings.xl});
    margin-top: ${({ theme }) => theme.spacings.xl};
    padding: ${({ theme }) => theme.spacings.xl};
    position: relative;
    width: 100%;
  }
`;
//# sourceMappingURL=BaseMobile.js.map